var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileCopyActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9618 8.18728C15.729 7.94234 15.4073 7.8 15.0694 7.8H5.9997C4.67422 7.8 3.59971 8.87451 3.5997 10.2L3.59961 24.5999C3.5996 25.9254 4.67411 26.9999 5.9996 27L16.7996 27C18.1251 27 19.1996 25.9255 19.1997 24.6001L19.2 11.8778C19.2 11.571 19.0829 11.276 18.87 11.0551C18.4762 10.6466 17.8186 9.97452 17.4 9.6C16.8659 9.12214 16.3117 8.55538 15.9618 8.18728Z",
    fill: "#B7C0EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2694 3H21.6V6.6C21.6 7.26274 22.1372 7.8 22.8 7.8H26.4L26.4 7.07783C26.4 6.77099 26.2829 6.47604 26.07 6.25513C25.6762 5.84665 25.0186 5.17452 24.6 4.8C24.0659 4.32214 23.5117 3.75538 23.1618 3.38728C22.929 3.14233 22.6073 3 22.2694 3Z",
    fill: "#B7C0EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 7.8V11.4C14.4 12.0627 14.9372 12.6 15.6 12.6H19.2M21.6 3H13.1997C11.8742 3 10.7997 4.07451 10.7997 5.39999V7.8M21.6 3H22.2694C22.6073 3 22.929 3.14233 23.1618 3.38728C23.5117 3.75538 24.0659 4.32214 24.6 4.8C25.0186 5.17452 25.6762 5.84665 26.07 6.25513C26.2829 6.47604 26.4 6.77099 26.4 7.07783L26.4 7.8M21.6 3V6.6C21.6 7.26274 22.1372 7.8 22.8 7.8H26.4M26.4 7.8L26.3997 19.8001C26.3996 21.1255 25.3251 22.2 23.9996 22.2H19.1996M17.4 9.6C16.8659 9.12214 16.3117 8.55538 15.9618 8.18728C15.729 7.94234 15.4073 7.8 15.0694 7.8H5.9997C4.67422 7.8 3.59971 8.87451 3.5997 10.2L3.59961 24.5999C3.5996 25.9254 4.67411 26.9999 5.9996 27L16.7996 27C18.1251 27 19.1996 25.9255 19.1997 24.6001L19.2 11.8778C19.2 11.571 19.0829 11.276 18.87 11.0551C18.4762 10.6466 17.8186 9.97452 17.4 9.6Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopyActiveIcon);
export default __webpack_public_path__ + "static/media/FileCopyActiveIcon.9a28e9a1be283e04ad7df7eaf4185c78.svg";
export { ForwardRef as ReactComponent };